import { memo } from 'react';
import { LoaderSpinner } from '@components/loader-spinner';

import { getActiveState } from './utils/get-active-state';
import { getToggleCircleClass } from './utils/get-toggle-circle-class';
import { getToggleContainerClass } from './utils/get-toggle-container-class';
import { SwitchToggleProps } from './switch-toggle.type';

const SwitchToggle = ({
  active,
  loading,
  activeIcon,
  inactiveIcon,
  onToggleSwitch,
  disabled,
  reverseOperation,
  ariaLabel = 'Switch Toggle',
  dataTestId,
}: SwitchToggleProps) => {
  const activeState = getActiveState(active, reverseOperation);
  const toggleContainerClass = getToggleContainerClass({ loading, activeState, disabled });
  const toggleCircleClass = getToggleCircleClass({ activeState, loading, disabled });

  const handleToggleClick = (e: React.KeyboardEvent | React.MouseEvent) => {
    if (loading || disabled) return;
    onToggleSwitch(!active, e);
  };

  return (
    <div
      data-testid={dataTestId}
      className={toggleContainerClass}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleToggleClick(e);
        }
      }}
      role='switch'
      tabIndex={0}
      onClick={handleToggleClick}
      aria-label={ariaLabel}
      aria-checked={activeState}
      aria-disabled={loading || disabled}
      aria-busy={loading}>
      <div className={toggleCircleClass}>
        {loading && <LoaderSpinner dataTestId='spinner' />}
        {activeState && !loading && activeIcon && activeIcon}
        {!activeState && !loading && inactiveIcon && inactiveIcon}
      </div>
    </div>
  );
};

export default memo(SwitchToggle);
